module.exports = __webpack_public_path__ + "images/start-2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/start-2x.png
// module id = 1132
// module chunks = 1